import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm, useFormContext } from "react-hook-form";

import type { CreateBrandFormValues } from "./createBrandsSchema";

import { CreateBrandFormValuesZod } from "./createBrandsSchema";

interface BrandsFormProps {
  children: React.ReactNode;
}

export function BrandsForm({ children }: BrandsFormProps) {
  const formMethods = useForm<CreateBrandFormValues>({
    defaultValues: {
      brandName: "",
      brandWebAddress: "",
      guidelineS3Key: null,
      logoS3Key: null,
    },
    mode: "onSubmit",
    resolver: zodResolver(CreateBrandFormValuesZod),
  });

  return (
    <FormProvider {...formMethods}>
      <div className="flex flex-col items-center mx-auto w-[23.5rem] md:w-[34.5rem] rounded-[24px] bg-bg-primary pt-[30px] pb-6 px-8 gap-4 shadow-[0_20px_24px_-4px_rgba(16,24,40,0.08),0_8px_8px_-4px_rgba(16,24,40,0.03)]">
        {children}
      </div>
    </FormProvider>
  );
}

export function useCreateBrandFormContext() {
  return useFormContext<CreateBrandFormValues>();
}
